
import { Component } from '@angular/core';

@Component({
  template: '<contact-details-tab></contact-details-tab>',
})
export class PersonalContactTabComponent { }
